import React from "react";
import ScrollCarousel from "./ScrollCarousel";
import { PROMO_BANNERS } from "../mock";

// "Limited Time Promo" — wide promotional banner cards. Uses the shared
// fixed-width scroll-snap track (like the other sections) so the banners always
// stay on a single row and scroll horizontally, including on mobile.
export default function LimitedTimePromo() {
  return (
    <section className="v2-section" id="limited-promo-v2">
      <h2 className="v2-section__title">Limited Time Promo</h2>
      <ScrollCarousel trackClassName="v2-promo__track" step={396}>
        {PROMO_BANNERS.map((b) => (
          <div key={b.id} className="v2-promo-card">
            <img src={b.image} alt="Promotion" />
          </div>
        ))}
      </ScrollCarousel>
    </section>
  );
}
